module.exports = __webpack_public_path__ + "img/visual-frontpage.1524e641.jpg";